export const MIN_SEARCH_LENGTH = 2;

export function filterItemsBySearch(items, searchValue, minLength = MIN_SEARCH_LENGTH) {
  if (!searchValue || searchValue.length < minLength) {
    return items;
  }
  const query = searchValue.toLowerCase();
  return items.filter((item) =>
    Object.values(item).join("").toLowerCase().includes(query)
  );
}
